var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ezukit-player",style:(_vm.containerStyles)},[_c('div',{ref:"playWind",staticClass:"player-container",attrs:{"id":_vm.playerId}}),(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v(" 正在加载播放器... ")]):_vm._e(),(_vm.error)?_c('div',{staticClass:"error-message"},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }